<template>
  <div class="forget-Word">
      <div class="top">
            <div @click="$router.go(-1)">返回</div>
            <div>忘记密码</div>
      </div>
      <div class="line"></div>
      <div class="step">
          <div :class="item.num==active ? 'title-hover':'title'" v-for="item in TitleList" :key="item.num">
              <div>{{item.num}}</div>
              <div>{{item.title}}</div>
          </div>
      </div>
      <div class="box" :class="[ active == 1? 'box-height1': '', active ==2 ? 'box-height2' : '', active == 3 ? 'box-height3':'']">
          <div v-if="active==1">
            <div class="login-pass bbox">
                <input class="input" type="text" oninput="this.value=this.value.replace(/\s+/g,'')" v-model="params.username" placeholder="请输入登录账号" />
                <input type="text" oninput="this.value=this.value.replace(/\s+/g,'')" style="display: none"/>
                <div class="show_pass">
                    <input class="input" type="text" oninput="this.value=this.value.replace(/\s+/g,'')"  placeholder="请输入验证码" v-model="params.code">
                    <div class="show_img">
                        <div class="send-code" @click="sendCode" v-if="codeTime<=0">发送验证码</div>
                        <div class="send-code" v-else>{{this.codeTime}}s</div>
                    </div>
                </div>
            </div>

            <div style="color: #0981FF;font-size: 14px;margin:20px 100px">
                验证码会通过繁星门店端公众号消息推送，请使用小程序登录手机登录【繁星门店 端】小程序，并关注公众号以查收验证码
            </div>

            <div style="color: #333333;font-size: 18px;font-weight: bold;margin:20px 100px">
                若未关注公众号，请先关注繁星门店端公众号
            </div>

            <div class="two_code">
                <img src="./images/code.jpg" alt="">
            </div>
          </div>
          <div v-else-if="active==2" class="bbox">
              <input class="input" type="password" oninput="this.value=this.value.replace(/\s+/g,'')" placeholder="请输入6-16位含字母或数字的新密码" v-model="params.pwd" > 
              <input class="input" type="password" oninput="this.value=this.value.replace(/\s+/g,'')" placeholder="请重新输入密码" v-model="params.pwdAgin" > 
              <div v-if="pwaStatus" style="font-size: 14px;font-weight: 400;color: #FF687B;">提示：两次请输入相同密码</div>
          </div>
          <div v-else-if="active==3">
              <div class="title-t">提示</div>
              <div class="Toast">
                  <div><img src="./images/icon_cg.png" alt=""></div>
                  <div>密码已重置成功，请返回登录页重新填写密码登录。</div>
              </div>
          </div>
          <div class="botBtn bbox">
                <div class="btn left_b" style="margin-right:40px" @click="$router.go(-1)" v-if="active==1">
                    取消
                </div>
                <div class="btn left_b" style="margin-right:40px" @click="activClick" v-if="active==2">
                    上一步
                </div>
                <div class="btn right_b" @click="nextClick" v-if="active==1">
                    下一步
                </div>
                <div class="btn right_b" @click="nextClickPwd" v-if="active==2">
                    下一步
                </div>
                <div class="btn right_b mar-l155" @click="$router.push('/login')" v-if="active==3">
                    返回登录页
                </div>
          </div>
      </div>
  </div>
</template>

<script>
// import Form from "./Form"
// import Table from "./Table"
import _api from "@/utils/request";
export default {
  name: 'forget-Word',
//   components: {Form, Table},
  data(){
    return{
        pwaStatus:false,
        codeTime:0,
        TitleList:[
            {num:'1',title:'账号验证'},
            {num:'2',title:'填写新密码'},
            {num:'3',title:'重置成功'},
        ],
        active: 1,
        uuid:'',
        params: {
            username: '',
            code: '',
            pwd:'',
            pwdAgin:'',
        }
    }
  },
  methods:{
      nextClick() {
          if(this.params.code){
            const params =  {
                code:this.params.code,
                userAcc:this.params.username,
                type:'01'
            }
            _api.resetPwd(params).then(res=>{
                console.log(res)
                if(res.code==1){
                    this.active = 2
                }
            })
          }else{
              this.$message.error('请填写验证码')
          }
      },
      nextClickPwd(){
          if(!this.params.pwd || !this.params.pwdAgin){
              return this.$message.error('请填写密码')
          }
          if(this.params.pwd!==this.params.pwdAgin){
              this.pwaStatus = true
          }else{
              this.pwaStatus = false
              const params =  {
                code:this.params.code,
                userAcc:this.params.username,
                type:'02',
                newPassword:this.params.pwd,
                repeatPassword:this.params.pwdAgin
            }
            _api.resetPwd(params).then(res=>{
                console.log(res)
                if(res.code==1){
                    this.active = 3
                }
            })
          }
      },
      activClick(){
        this.active = 1;
      },
      sendCode(){
          _api.sendCode({userAcc:this.params.username,uuid:localStorage.getItem('uuid')}).then(res=>{
              console.log(res)
              if(res.code==1){
                  localStorage.setItem('uuid',res.data)
                  this.$message.success('验证码发送成功')
                  this.codeTime = 60
                    const timer = setInterval(() => {
                        this.codeTime -= 1
                        if (this.codeTime<=0) {
                            clearInterval(timer)
                        }
                    }, 1000)
                }
          })
      }
  },
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.forget-Word{
    background: white;
    .top{
        margin-top: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        div:first-child{
            margin: 0 10px 0 28px;
            width: 60px;
            height: 30px;
            line-height: 30px;
            color: #0981FF;
            background: #F2F8FE;
            border: 1px solid #0981FF;
            border-radius: 8px;
            cursor: pointer;
            font-size: 20px;
            text-align: center;
        }
        div:last-child{
            height: 30px;
            line-height: 30px;
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #333333;
        }
    }
    .line{
            margin-top: 20px;
            width: 100%;
            height: 1px;
            background: #0981FF;
        }
    .step{
        width: 700px;
        border-top:2px solid #0981FF;
        margin: -1px auto 0px auto;
        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        .title{
            display: flex;
            div:first-child{
                line-height: 28px;
                text-align: center;
                color: white;
                width: 28px;
                height: 28px;
                background: #999999;
                border-radius: 50%;
            }
            div:last-child{
                margin-left: 5px;
                font-size: 24px;
                line-height: 28px;
                height: 28px;
                font-family: PingFang SC;
                font-weight: bold;
                color: rgba(153, 153, 153, 1);
            }
        }
        .title-hover{
            display: flex;
            div:first-child{
                line-height: 28px;
                text-align: center;
                color: white;
                width: 28px;
                height: 28px;
                background: rgba(9, 129, 255, 1);
                border-radius: 50%;
            }
            div:last-child{
                margin-left: 5px;
                font-size: 24px;
                line-height: 28px;
                height: 28px;
                font-family: PingFang SC;
                font-weight: bold;
                color: rgba(9, 129, 255, 1);
            }
        }
    }
    .box-height1{
        height: 590px;
    }
    .box-height2{
        height: 440px;
    }
    .box-height3{
        height: 309px;
    }
    .box{
        margin: 50px auto;
        width: 700px;
        background: #FFFFFF;
        box-shadow: 0px 10px 27px 3px rgba(78, 130, 185, 0.2);
        border-radius: 20px;
        .bbox{
            margin:0 100px
        }
        .botBtn{
            width: 500px;
            margin-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .btn{
                width:150px;
                height: 50px;
                border-radius: 10px;
                line-height: 50px;
                text-align: center;
                cursor: pointer;
                font-size: 24px;
            }
            .left_b{
                background: #F2F8FE;
                border: 1px solid #0981FF;
                color: #0981FF;
            }
            .right_b{
                background: #0981FF;
                box-shadow: 0px 10px 27px 3px rgba(78, 130, 185, 0.2);
                color: white;
            }
            .mar-l155{
                margin-left: 155px;
            }
        }
        .two_code{
            margin: 20px 100px;
            width: 137px;
            height: 139px;
            img{
                width: 139px;
                object-fit: contain;
            }
        }
        .input {
          display: block;
          width: 100%;
          border: none;
          border-bottom: 1px solid #e7eaee;
          padding: 40px 0;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          outline: none;
          &::placeholder {
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #b6b9d0;
            outline: none;
          }
        }
        .show_pass{
            position: relative;
            .login-pass{
                margin-top: 50px;
            }
            .show_img{
                position: absolute;
                top: 35px;
                right: 100px;
                width: 25px;
                bottom: 10px;
                height: 25px;
                .send-code{
                    font-size: 18px;
                    width: 110px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: #F2F8FE;
                    cursor: pointer;
                    border: 1px solid #0981FF;
                    border-radius: 10px;
                    color: #0981FF;
                }
            }
        }
    }
    .title-t{
        margin: 0px auto;
        padding-top: 40px;
        width: 60px;
        height: 23px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
    }
    .Toast{
        padding-top: 80px;
        display: flex;
        justify-content: center;
        img{
            width: 24px;
            height: 24px;
            margin: 3px 10px 60px 0;
        }
        div:last-child{
            width: 487px;
            height: 21px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #333333;
        }
    }
}
</style>
